import { combineReducers } from 'redux';
import token from './token';
import refresh from './refresh';

export default combineReducers({
    token,
    refresh
});